__turbopack_context__.v({
  "nftAttribute": "NFTAttributes-module-scss-module__qiz7ZG__nftAttribute",
});
